import script from "./PropertyDetailsSideCards.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDetailsSideCards.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDetailsSideCards.vue?vue&type=style&index=0&id=154487c9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154487c9"]])

export default __exports__